<template></template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import { bus } from "../../main";
export default {
  name: "verifyuser",
  data() {
    return {
      users: [],
    };
  },
  mounted() {
    this.open();
  },
  methods: {
    open() {
      this.$prompt("Please input your system ID", "User Verification", {
        confirmButtonText: "Verify",
        cancelButtonText: "Cancel",
        closeOnClickModal: false,
        showCancelButton: false,
        showClose: false,
        center: true,
        customClass: ".promptBox",
        inputErrorMessage: "Invalid ID",
      })
        .then(({ value }) => {
          const docRef = this.$store.state.secondaryDatabase.collection("sysusers");
          let firestoreQuery = docRef;
          if(this.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
          } 
          firestoreQuery
            .where("sysid", "==", value)
            .limit(1)
            .get()
            .then((querySnapshot) => {
              // console.log("querySnapshot");
              querySnapshot.forEach((doc) => {
                const data = {
                  id: doc.id,
                  data: doc.data(),
                };
                this.users.push(data);
              });
              if (!this.users[0]) {
                this.$notify({
                  type: "error",
                  message: "User not found for ID " + value,
                });
                return this.open();
              }

              this.$store.state.systemUser.isLogedIn = true;
              this.$store.state.systemUser.role = this.users[0].data.role;
              this.$store.state.systemUser.permissions =
                this.users[0].data.permissions || [];
              this.$store.state.systemUser.stores =
                this.users[0].data.store || [];
              bus.$emit("userChanged", this.users[0].data);
              this.$store.state.systemUser.name = this.users[0].data.name;
              this.$store.state.systemUser.id = this.users[0].id;
              if (this.users[0].data.role === "Cashier" || this.users[0].data.role === 'Shop Manager')
                this.$router.push("/admin/createinvoice");
              else if (this.users[0].data.role === "Kitchen Staff" || this.users[0].data.role === "Service Staff")
                this.$router.push("/admin/kot");
              else this.$router.push("/admin");
            })
            .catch((error) => alert(error.message));
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error.message,
          });
        });
    },
  },
};
</script>

<style scoped>
.promptBox {
  width: 360px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/VerifyUser.vue